import { createSelector } from '@ngrx/store';
import { rulerAdapter } from './ruler.state';
import { selectDesign } from '@design/store/design.selector';

const { selectAll, selectEntities } = rulerAdapter.getSelectors();

const selectRulerState = createSelector(selectDesign, (state) => state.ruler);

export namespace fromRulerSelectors {
  export const selectAllRulers = createSelector(selectRulerState, selectAll);
  export const selectRulerEntities = createSelector(selectRulerState, selectEntities);
  export const selectSelectedRulerId = createSelector(
    selectRulerState,
    (state) => state.selectedRulerId
  );
  export const selectSelectedRuler = createSelector(
    selectRulerEntities,
    selectSelectedRulerId,
    (entities, id) => (id ? entities[id] ?? null : null)
  );
}
